<!-- Both the configure.vue and send.vue modals have a huge overlap regarding Slack message writing, points value choosing, -->
<!-- GIF selecting, and Slack preview rendering. As such, use this form with a slot for whatever the individual modals uniquely require.  -->
<template>
  <div class="f-as m-tx2 w-100p">
    <div class="fc-g1 w-0 m-rx1">
      <div class="f-v">
        <slot />
        <!-- Message -->
        <div class="t m-tx2">Message</div>
        <donut-input-text
          v-model="message"
          :placeholder="messagePlaceholder"
          :autocomplete="['emoji', 'users', 'channels', 'variables']"
          :autogrow="true"
          :textarea="true"
          :max-length="2500"
          class="m-t"
        />
        <!-- Image Url -->
        <div class="f-as m-tx2 w-100p">
          <button class="inv w-100p" @click="moveToGifModal">
            <i class="mi m-r">image</i>
            <span>Add GIF</span>
          </button>
          <button v-if="gifUrl" class="inv w-100p m-lx1" @click="() => gifUrl = null">
            <i class="mi m-r">delete</i>
            <span>Remove GIF</span>
          </button>
        </div>
        <!-- Points -->
        <div class="t m-tx2">Bonus amount</div>
        <div class="f-ac m-t">
          <input v-model="points" type="number" :min="1" :step="1" class="w-x12">
          <div v-emoji="exchangeRateCopy" class="t m-l" />
        </div>
        <div class="t m-t">Exchange rate (1 {{ pointsConfig.points_name }} = {{ centsPerPoint }}¢) applicable to gift cards when enabled.</div>
        <div class="t gray m-t">These points come from an infinite company account.</div>
      </div>
    </div>
    <donut-slack-preview class="fc-g1 w-0 m-lx1" :message="previewMessage">
      <div class="block"><div class="divider" /></div>
      <div class="block"><div v-slack-format="pointsReceiptText" class="text" /></div>
      <div v-if="gifUrl" class="block">
        <img class="w-100p" :src="gifUrl">
      </div>
    </donut-slack-preview>
  </div>
</template>

<script setup>
  import { computed, onBeforeMount } from 'vue';
  import { useStore } from 'vuex';

  const { state, commit } = useStore();

  const { pointsConfig, dollarsPerPoint } = state.bonusEventTemplates;

  const message = computed({
    get() { return state.bonusEventTemplates.activeTemplate.message; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'message', value }); },
  });
  const gifUrl = computed({
    get() { return state.bonusEventTemplates.activeTemplate.gifUrl; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'gifUrl', value }); },
  });
  const points = computed({
    get() { return state.bonusEventTemplates.activeTemplate.points; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'points', value }); },
  });

  // Message / Slack Preview
  const messagePlaceholder = 'Congratulations on this exciting new chapter! Here is a little something to celebrate.';
  const previewMessage = computed(() => message.value || messagePlaceholder);
  const pointsReceiptText = computed(() => {
    const bonus = `${points.value} ${pointsConfig.points_name} :${pointsConfig.emoji}:`;
    return `You received a ${bonus} bonus.`;
  });

  // GIF
  const moveToGifModal = () => {
    commit('updateModal', {
      visible: true,
      subcomponent: 'onboarding-events-modals-gif-search',
      data: { attachGif: (url) => { gifUrl.value = url; } },
      size: 'xxl',
      cancelMutation: 'updateModal',
      cancelArgs: state.modal,
    });
  };

  // Points
  const centsPerPoint = Math.round(dollarsPerPoint * 100);

  const exchangeRateCopy = computed(() => {
    const value = (dollarsPerPoint * points.value).toFixed(2);
    return `:${pointsConfig.emoji}: = $${value} per recipient`;
  });

  // Lifecycle Hooks
  onBeforeMount(() => {
    Donut.Args.otherVariables = ['Recipient'];
  });
</script>
